<template>
  <!-- Two crossed drumsticks, drawn like the Material Design icons (the icon font has nothing for percussion). -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true">
    <g stroke="currentColor" stroke-width="2" stroke-linecap="round">
      <line x1="6" y1="6" x2="20" y2="21"/>
      <line x1="18" y1="6" x2="4" y2="21"/>
    </g>
    <circle cx="5.5" cy="4.5" r="2.8"/>
    <circle cx="18.5" cy="4.5" r="2.8"/>
  </svg>
</template>

<script>
export default {name: 'DrumIcon'};
</script>
